export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 424.7,
    source: "https://bit-digital.com/press-releases/bit-digital-announces-bitcoin-mining-production-of-424-7-bitcoin-for-january-2021/"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 2.48,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 72.24,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 739.51,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 695.97,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-2020-financial-highlights/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 1013.4,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-first-quarter-of-fiscal-year-2021-financial-results/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 562.9,
    source: "https://bit-digital.com/press-releases/bit-digital-inc-announces-second-quarter-of-fiscal-year-2021-financial-results/"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
